export default {
    key: 'first',
    common: {
        productName: 'core.productNames.first',
        splashMessage: 'offerFlow.splashMessage.first',
        headingAside: 'offerFlow.headingAside.first',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.first',
    },
    stepTripSelection: {
        heading: 'offerFlow.pages.stepTripSelection.heading.common',
        body: 'offerFlow.p2p.dayTicket',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.p2p',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
